import { createRouter, createWebHashHistory } from "vue-router";
import model from "../vue/store/model";

const Home = () => import("../views/home/HomeView.vue");
const routes = [{ path: "/", name: "Home", component: Home }];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (
    to.name != "Login" &&
    to.name != "/" &&
    to.name != "LoginRegister" &&
    to.name != "Register" &&
    Object.keys(model.LoginInfo).length == 0
  ) {
    next();
  } else {
    next();
  }

  // next();
});

export default router;
